import * as moment from 'moment';

export default (date: string): number => moment(date).date();
